// fade.animation.ts

import { trigger, animate, transition, style } from '@angular/animations';

export const fadeInAnimation =

    trigger('fadeInAnimation', [

        transition( ':enter', [
            style({ 
                opacity: 0,
                backgroundColor: 'rgba(0, 0, 0, 0)'
             }),
            animate('1.33s', style({ opacity: 1 })),
        ]),

    ]);